import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: null,
        user_id: null,
        user_rfc: null,
        user: null,
        role: null,
        name: null
    },
    mutations: {
        authUser(state, userData) {
            state.token = userData.token;
            state.role = userData.role;
            state.user_id = userData.user_id;
            state.user = userData.user;
            state.user_rfc = userData.user_rfc;
            state.name = userData.name;
        },
        errorLogin(state, message) {
            state.error = message.message
        },
        cleanErrors(state) {
            state.error = false
        },
    },
    actions: {
        login() {

        },
        logout() {
            localStorage.clear()
        },
    },
    getters: {
        token: state => state.token,
        role: state => state.role,
        user: state => state.user,
        name: state => state.name,
        user_rfc: state => state.user_rfc,
        user_id: state => state.user_id
    }
})
